<template>
    <div class="userInput-wrap">
        <div class="userInput-content-wrap">
            <div
                class="userInput-content"
                :class="{ userInputSjtu: owner === 'SJTU' }"
                @touchstart.stop.prevent="startHandleAudio"
                @touchend.stop.prevent="stopHandleAudio"
            >
                <i v-if="content !== curAudioSrc || (content === curAudioSrc && ifPause)" class="iconfont icon-ecard-voice"></i>
                <img v-if="content === curAudioSrc && !ifPause" src="../assets/imgs/voice-blue.gif" alt />
                <div v-if="showAsrTip && (asr || (isRequest && !asr))" class="asr-tip">
                    转文字
                    <span></span>
                </div>
            </div>
            <div v-if="showAsr" class="asr-wrap">
                <div v-if="isRequest && !asr">
                    <i class="iconfont icon-reload"></i>
                </div>
                <div v-if="asr">{{ animationAsr }}</div>
                <div v-if="showAsrFinished" class="tip">
                    <i class="iconfont icon-check-circle-fill"></i>
                    <span>转换完成</span>
                </div>
            </div>
        </div>
        <div class="userInput-portrait" v-if="owner !== 'SJTU'">
            <i class="iconfont icon-ecard-head-portrait"></i>
        </div>
    </div>
</template>

<script>
let timer

export default {
  props: {
    content: {
      type: String
    },

    curAudioSrc: {
      type: String
    },

    isRequest: {
      type: Boolean
    },

    asr: {
      type: [String, undefined, Boolean]
    },
    owner: String
  },

  data () {
    return {
      ifPause: false,
      showAsrTip: false,
      showAsr: false,
      showAsrFinished: false,
      animationAsr: ''
    }
  },

  watch: {
    curAudioSrc (val) {
      if (this.content !== val) {
        this.ifPause = false
      }
    },

    showAsr (val) {
      if (val && this.asr) {
        this.createAnimationAsr()
      }
    },

    asr (val) {
      if (val && this.showAsr) {
        this.createAnimationAsr()
      }
    },

    isRequest (val) {
      if (!val && !this.asr) {
        this.showAsr = false
      }
    }
  },

  methods: {
    startHandleAudio () {
      if (this.content === this.curAudioSrc) {
        this.ifPause = !this.ifPause
      }

      this.$emit('setCurAudioSrc', 'input', this.content)
      if (!this.showAsr) {
        const touchIconTime = Date.now()
        timer = setInterval(_ => {
          if (Date.now() - touchIconTime > 600) {
            this.showAsrTip = true

            if (this.isRequest || this.asr) {
              this.showAsr = true
            }
            clearInterval(timer)
            timer = null

            setTimeout(_ => {
              this.showAsrTip = false
            }, 800)
          }
        }, 200)
      }
    },

    stopHandleAudio () {
      clearInterval(timer)
      timer = null
      this.showAsrTip = false
    },

    createAnimationAsr () {
      let i = 1
      let timer = setInterval(_ => {
        if (this.asr.length !== 0 && this.asr.length === this.animationAsr.length) {
          clearInterval(timer)
          timer = null
          this.showAsrFinished = true
          return
        }

        this.animationAsr = this.asr.slice(0, ++i)
      }, 120)
    }
  }
}
</script>

<style lang="scss" scoped>
.userInput {
    &-wrap {
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;

        &:not(:first-child) {
            margin-top: 44px;
        }
    }

    &-content-wrap {
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .asr-wrap {
            margin-top: 20px;
            max-width: 432px;
            padding: 14px 22px;
            background: #f0f2f5;
            color: #111e2e;
            font-size: 32px; /*px*/
            border-radius: 8px;

            @keyframes spin {
                from {
                    transform: rotate(0deg);
                }
                to {
                    transform: rotate(360deg);
                }
            }

            .icon-reload {
                display: inline-block;
                margin-right: 40px;
                font-size: 28px; /*px*/
                animation: spin 1s infinite linear;
            }

            .tip {
                margin-top: 10px;
                color: #c3c7cb;

                .iconfont {
                    margin-right: 6px;
                    font-size: 28px; /*px*/
                    vertical-align: text-bottom;
                }

                > span {
                    font-size: 24px;
                }
            }
        }
    }

    &-content {
        position: relative;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: 144px;
        line-height: 40px;
        padding: 12px 32px;
        border-radius: 32px;
        background: #4e82ff;

        .iconfont {
            font-size: 36px; /*px*/
            color: #345fd4;
            user-select: none;
        }

        img {
            width: 40px;
            user-select: none;
        }

        .asr-tip {
            position: absolute;
            bottom: 100%;
            right: 20px;
            margin-bottom: 16px;
            padding: 18px 24px;
            color: #ffffff;
            background: #111e2e;
            border-radius: 12px;
            white-space: nowrap;

            > span {
                position: absolute;
                top: 72px;
                right: 30px;
                border-top: 12px solid #111e2e;
                border-left: 12px solid transparent;
                border-right: 12px solid transparent;
            }
        }
    }

    &-portrait {
        margin-left: 20px;
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        background: #dcdcdc;

        .iconfont {
            color: #ffffff;
            font-size: 32px; /*px*/
        }
    }
}
.userInputSjtu {
    background: #016aed !important;
    .iconfont {
        color: #ffffff;
        font-size: 32px; /*px*/
    }
}
</style>



// WEBPACK FOOTER //
// src/app/GenH5/UserInputVoice.vue